import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const PUBLIC_API = `${BACKEND_URL}/api/public/settings`;

// Cache ne memorje + localStorage qe te mos blink-oje "DentArt" cdo refresh
let _cache = null;
let _inflight = null;

function readCache() {
  try {
    const raw = localStorage.getItem("dentart_public_settings");
    if (raw) return JSON.parse(raw);
  } catch (e) {}
  return null;
}

const DEFAULTS = {
  clinic_name: "DentArt",
  clinic_phone: "",
  clinic_address: "",
  clinic_email: "",
  currency: "ALL",
  currency_symbol: "L",
  timezone: "Europe/Tirane",
};

export function usePublicSettings() {
  const [settings, setSettings] = useState(_cache || readCache() || DEFAULTS);

  useEffect(() => {
    if (_cache) {
      setSettings(_cache);
      return;
    }
    if (!_inflight) {
      _inflight = axios.get(PUBLIC_API).then(({ data }) => {
        _cache = { ...DEFAULTS, ...data };
        try { localStorage.setItem("dentart_public_settings", JSON.stringify(_cache)); } catch (e) {}
        return _cache;
      }).catch(() => DEFAULTS).finally(() => { /* keep _inflight cached */ });
    }
    _inflight.then((data) => setSettings(data));
  }, []);

  return settings;
}
